// PWA glue: service worker registration (production only) and an install-prompt helper.

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
}

let deferred: BeforeInstallPromptEvent | null = null;

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e as BeforeInstallPromptEvent;
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
  });

  const shot = new URLSearchParams(window.location.search).has("shot");
  if (import.meta.env.PROD && "serviceWorker" in navigator && !shot) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
    });
  }
}

/**
 * Returns a function that shows the browser's install prompt (resolving true if the player accepted),
 * or null when no prompt is available (already installed, unsupported browser, or not yet offered).
 * Call it again each time the menu opens: a prompt can only be used once.
 */
export function installPrompt(): (() => Promise<boolean>) | null {
  const ev = deferred;
  if (!ev) return null;
  return async () => {
    deferred = null;
    await ev.prompt();
    const choice = await ev.userChoice;
    return choice.outcome === "accepted";
  };
}
